// src/components/calendar/MiniMonth.jsx
import React from "react";
import styles from "../../pages/CalendarGeneral.module.css";

function buildMatrix(date) {
  const y = date.getFullYear();
  const m = date.getMonth();
  const first = new Date(y, m, 1);
  const startDay = first.getDay();
  const days = new Date(y, m + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}

export default function MiniMonth({ value, selectedDate, onChange }) {
  const today = new Date();
  const matrix = buildMatrix(value);

  const isToday = (d) =>
    d &&
    today.getFullYear() === value.getFullYear() &&
    today.getMonth() === value.getMonth() &&
    today.getDate() === d;

  const isSelected = (d) =>
    d &&
    selectedDate &&
    selectedDate.getFullYear() === value.getFullYear() &&
    selectedDate.getMonth() === value.getMonth() &&
    selectedDate.getDate() === d;

  return (
    <>
      <div className={styles.weekDays}>
        {["일","월","화","수","목","금","토"].map((w) => (
          <div key={w} className={styles.weekDay}>{w}</div>
        ))}
      </div>
      <div className={styles.days}>
        {matrix.map((d, i) => {
          const classes = [styles.day];
          if (!d) classes.push(styles.otherMonth);
          if (isToday(d)) classes.push(styles.todayCircle); // 오늘 = 동그라미
          if (isSelected(d)) classes.push(styles.selected); // 선택 = 파란 배경
          return (
            <div
              key={i}
              className={classes.join(" ")}
              onClick={() => d && onChange(new Date(value.getFullYear(), value.getMonth(), d))}
            >
              {d ?? ""}
            </div>
          );
        })}
      </div>
    </>
  );
}
